type RehypeNode = {
  type: string;
  tagName?: string;
  properties?: Record<string, unknown>;
  children?: RehypeNode[];
  value?: string;
};

export function rehypeWrapTables() {
  return (tree: RehypeNode) => {
    const walk = (node: RehypeNode): void => {
      if (!node.children) {
        return;
      }

      node.children = node.children.flatMap((child) => {
        walk(child);

        if (child.type === 'element' && child.tagName === 'table') {
          return [
            {
              type: 'element',
              tagName: 'div',
              properties: { className: ['markdown-table-wrap'] },
              children: [child],
            },
          ];
        }

        return [child];
      });
    };

    walk(tree);
  };
}
